import { connect } from 'react-redux'
import DownloadItemsComponent from '../components/DownloadItemsComponent.jsx';
import {
	changeDownloadItemsValue,
	generateItemsFile,
	generateItemsFile2,
	cleanDownloadItemsAlert,
	findOrdersWithShipment
} from '../actions';

function showDownload1(roles) {
	return roles.includes("ROLE_FIREFIGHTER_ADMIN");
}

const mapStateToProps = (state) => ({
	formBean: state.getIn(['downloadItemsReducer', 'formBean']),
	formBeanValidation: state.getIn(['downloadItemsReducer', 'formBeanValidation']),
	alertStyle: state.getIn(['downloadItemsReducer', 'alertStyle']),
	alertMessage: state.getIn(['downloadItemsReducer', 'alertMessage']),

	allOrderIds: state.getIn(['downloadItemsReducer', 'allOrderIds']),
	showDownload1:showDownload1(state.getIn(['authReducer', 'roles']).toJS())
})

const mapDispatchToProps = (dispatch) => ({
	setValue: (id, value) => {
		dispatch(changeDownloadItemsValue({
			id: id,
			value: value
		}))
	},
	generateItemsFile: (bean) => {
		dispatch(generateItemsFile(bean));
	},
	generateItemsFile2: (bean) => {
		dispatch(generateItemsFile2(bean));
	},
	cleanAlert: () => {
		dispatch(cleanDownloadItemsAlert());
	},
	findAllOrderIds: () => {
		dispatch(findOrdersWithShipment());
	}
})

const DownloadItemsContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DownloadItemsComponent)

export default DownloadItemsContainer;


// WEBPACK FOOTER //
// ./src/containers/DownloadItemsContainer.jsx